var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1037_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.0223 62.4073C89.0223 83.136 72.157 100 51.4297 100H38.1226C35.9174 100 34.1304 98.2132 34.1304 96.008V94.6772C34.1304 92.4718 35.9172 90.685 38.1226 90.685H51.4297C67.0214 90.685 79.7074 77.999 79.7074 62.4073C79.7074 46.8157 67.0214 34.1297 51.4297 34.1297H26.8788L43.787 51.0378C45.603 52.8532 45.603 55.8085 43.787 57.6239C42.0248 59.3847 38.958 59.3821 37.1998 57.6239L12.3422 32.7657C11.4626 31.886 10.9778 30.7164 10.9778 29.472C10.9778 28.2284 11.4626 27.0581 12.3422 26.1789L37.2011 1.31958C38.9593 -0.439942 42.0288 -0.439942 43.7872 1.31958C45.6032 3.13451 45.6032 6.09028 43.7872 7.90499L26.879 24.8145H51.4297C72.157 24.8145 89.0223 41.6791 89.0223 62.4073Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1037_882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.f5cdcc057bd158f39b86423146dbdf37.svg";
export { ForwardRef as ReactComponent };